import React from "react";
import { Checkbox, Flex, Form } from "antd";
import { Controller } from "react-hook-form";
import { CheckboxFieldProps } from "./types";
import spacing from "theme/spacing.module.scss";
import colors from "theme/colors.module.scss";

export const CheckboxField = ({ name, control, label }: CheckboxFieldProps) => {
    return (
        <Form.Item style={{ marginBottom: spacing.spacingSM }}>
            <Controller
                name={name}
                control={control}
                render={({ field, fieldState: { error } }) => (
                    <Flex vertical gap={4}>
                        <Checkbox
                            checked={!!field.value}
                            onChange={(e) => field.onChange(e.target.checked)}
                        >
                            {label}
                        </Checkbox>
                        {error && (
                            <span style={{ color: colors.accentRed500 }}>{error.message}</span>
                        )}
                    </Flex>
                )}
            />
        </Form.Item>
    );
};
